module.exports = __webpack_public_path__ + "img/bg3.75e023f9.jpg";